import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

export default function ProtectedRoute({ role }) {

  const { user } = useAuth();

  const token = localStorage.getItem("token");
  const storedRole = localStorage.getItem("role");

  // अगर token नहीं है तो login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // अगर role mismatch है
  if (role && storedRole !== role) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}